<template>
  <div>
    <div style="background:#f4f4f4; border-top:2px solid #ddd;">
      <div class="widM fntH4 bold padTS padBS" style="color:#2c2c2c;">참가자 정보</div>
    </div>
    <div class="widM padTM">
      <ul class="osResNoticeList fntE colorGray" style="padding-left:.5em; text-indent:-.5em;">
        <li>- <em style="color:#e11e45">*</em> 표시는 필수 입력사항입니다.</li>
        <li>- 첨부파일은 JPG, PNG, PDF 형식으로 최대 10MB까지 등록하실 수 있습니다.</li>
      </ul>
    </div>

    <div class="widM NCAcmi_cont01_wrap">
      <div class="clearfix" v-if="mainResponses">
        <template v-for="(mainAttendant, idx) in mainResponses">
          <SurveyParticipant
            :key="`mainAttendant${idx}`"
            :seq="idx"
            :participant="mainAttendant"
          />
          <span
            :key="`mainAttendant_span${idx}`"
            class="disIb moOnly" style="padding:2.5px;"
          />
          <hr
            v-if="idx < mainResponses.length - 1"
            :key="`mainAttendant_hr${idx}`"
            class="moOnly"
            style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
          />
        </template>
      </div>
    </div>

    <template v-if="existMemberAttendant">
      <!-- 동반 가족 정보 -->
      <div class="marTML" style="background:#f4f4f4; border-top:2px solid #ddd;">
        <div class="widM fntH4 bold padTS padBS" style="color:#2c2c2c;">동반가족 정보</div>
      </div>

      <div class="widM">
        <div class="NCAcmi_family padTM">
          <div class="floL fntP">참여 여부 <span class="ico-must-astar"></span></div>
          <div class="floR NCAcmi_family_attend">
            <div class="amway-theme txtR">
              <div class="action NCAcmi_radioBtn radio-wrapper NCAcmi_family_radio NCAcmi_familyN">
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    name="radio-family"
                    class="amw-global-radio"
                    value="Y"
                    v-model="familyAttendanceYn"
                    :disabled="!infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">참여</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    name="radio-family"
                    class="amw-global-radio"
                    value="N"
                    v-model="familyAttendanceYn"
                    :disabled="!infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">불참</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="widM marBML">
        <div class="fntP bold padTM" style="color:#012f60;">동반 가족 범위(도표)</div>
        <div class="padTM padBM marTS" style="background:#f5f5f5;">
          <div class="osResTbScrollWrap widM" style="border: none; box-shadow: none;">
            <div class="osResTbScroll"> 
              <p class="bold padLM fntH6"><span style="color:#002f5f;">기존 /</span> <span style="color:#d0824d;">추가</span></p>
              <img src="../images/cont01_family_chart.png" class="padM" alt="새로운 동반 가족 범위(도표) - 기존 2촌 이내 가족에서 3촌 이내 가족으로 동반 가족 범위가 확대됩니다.">
              <p class="marTSM" style="color:#002f5f;">※ 만 12세 이하의 어린이는 현지에서 진행되는 모든 프로그램에 보호자를 동반하여야 참여할 수 있음.</p>
            </div>
          </div>
        </div>
      </div>
      <template v-if="familyAttendanceYn === 'Y'">
        <template v-for="(family, idx) in familyResponses">
          <hr
            :key="`familyResponses_hr${idx}`"
            style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
          />
          <SurveyParticipantFamily
            :key="`familyResponses${idx}`"
            :idx="idx"
            :participant="family"
          />
        </template>

        <template v-if="infoAvailable && !isExceededFamilyCountLimit">
          <hr class="padBS" style="border-color: #ddd;">
          <a
            @click="addNewFamily"
            class="widM NCAcim_familyN_plus"
            :class="{ NCAcmi_familyN_Btn: !canAddFamily }"
            :style="{ cursor: canAddFamily ? 'pointer' : 'default' }"
          >
            <div class="padTSM padBSM" style="display:flex; justify-content: center; align-items: center;">
              <div class="padRM"><img src="../images/NCAcmi_plus.png" alt="플러스 아이콘" style="max-width:30px;"></div>
              <div class="txtL" style="color:#fff; line-height:2;">
                <p class="fntP regular">동반가족 추가</p>
              </div>
            </div>
          </a>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import SurveyParticipant from './SurveyParticipant.vue'
import SurveyParticipantFamily from './SurveyParticipantFamily.vue'
import { SURVEY, INFO_AVAILABLE, ATTENDING_LIST, MAIN_RESPONSES, FAMILY_RESPONSES, ADD_NEW_FAMILY, FAMILY_ATTENDANCE_YN, SET_FAMILY_ATTENDANCE_YN, MEMBER_ATTENDANTS, FAMILY_ATTENDANTS } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import { getMessage } from '@/utils/survey'

export default {
  name: 'SurveyParticipantInfo',
  mixins: [CommonMethodMixin],
  components: {
    SurveyParticipant,
    SurveyParticipantFamily,
  },
  computed: {
    ...mapState(SURVEY, {
      responses: state => state.responses,
    }),
    ...mapGetters(SURVEY, {
      infoAvailable: INFO_AVAILABLE,
      attendingList: ATTENDING_LIST,
      mainResponses: MAIN_RESPONSES,
      familyResponses: FAMILY_RESPONSES,
      familyAttendants: FAMILY_ATTENDANTS,
      family_attendance_yn: FAMILY_ATTENDANCE_YN,
      memberAttendants: MEMBER_ATTENDANTS,
    }),
    existMemberAttendant () {
      return this.memberAttendants.length > 0;
    },
    familyAttendanceYn: {
      get() {
        return this.family_attendance_yn;
      },
      set(yn) {
        this.$store.commit(`${SURVEY}/${SET_FAMILY_ATTENDANCE_YN}`, yn);
      }
    },
    // 마지막 동반가족 추가 폼 작성 여부
    isFormFilledCompletely() {
      const lastFamilyIndex = this.familyResponses.length - 1;
      const lastFamily = this.familyResponses[lastFamilyIndex];
      const { name, questions, paymentInfo } = lastFamily;

      if(!name || name.trim() === '') {
        return false;
      }
      if((!questions['Q014_1'].raw_data || questions['Q014_1'].hasError)
        || (!questions['Q014_2'].raw_data || questions['Q014_2'].hasError)) {
        return false;
      }
      if(!(questions['Q015'].path && questions['Q015'].original_name)) {
        return false;
      }
      
      // 결제 정보 체크(총 참석 인원수가 4명 이상 이면 결제 정보를 입력해야함)
      if(this.attendingList.length >= 4 && !paymentInfo) {
        return false;
      }

      return true;
    },
    // 동반가족 최대 동반 인원(5) 초과 여부
    isExceededFamilyCountLimit() {
      return this.familyAttendants.length >= 5;
    },
    // 동반가족 추가 버튼 활성화 가능 여부
    canAddFamily() { // 폼 작성 완료
      return this.isFormFilledCompletely;
    }
  },
  methods: {
    addNewFamily(e) {
      if(!this.canAddFamily) return false;

      if(this.attendingList.length >= 3) {
        if(!confirm(getMessage('CONFIRM_ATTENDANT_RULE1'))) {
          return false;
        }
      }

      this.$store.dispatch(`${SURVEY}/${ADD_NEW_FAMILY}`, 'Y');
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyParticipantInfo.vue